<template>
    <div id="meters-report" class="pt-8">
        <labeled-card :label="$t('Отчет по оформленным Актам на отключение / подключение')">
            <v-container fluid class="pl-4">
                <v-row>
                    <v-col cols="3">
                        <v-radio-group row v-model="report_category">
                            <v-radio
                                color="gray"
                                v-for="category in report_categories"
                                :key="category.label"
                                :label="category.label"
                                :value="category.value"
                            ></v-radio
                        ></v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <pre-trial-date-picker label="Период" isRange :date.sync="period" />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            outlined
                            :label="$t('Инженер ЭР')"
                            :items="itemsEngineer"
                            item-text="person_ea_name_show"
                            item-value="isas_engineer_rid"
                            v-model="engineer_rid"
                            :disabled="!isRoleManagementReport"
                            multiple
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <v-autocomplete
                            outlined
                            :label="$t('Действие по акту')"
                            :items="actions"
                            item-text="action_name"
                            item-value="record_id"
                            v-model="action_type_rid"
                            multiple
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            outlined
                            :label="$t('Причина')"
                            :items="reasons"
                            item-text="reason_name"
                            item-value="record_id"
                            v-model="action_reason_rid"
                            multiple
                            clearable
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col lg="3" md="4" sm="6">
                        <v-btn class="spacer" :loading="isLoading" dark color="info" @click.stop="generateReport">{{ $t('reports.labels.button') }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </labeled-card>
    </div>
</template>

<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import LabeledCard from '@/components/ui/LabeledCard';
import translate from '@/utils/translate.util';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
    name: 'ReportPreTrialNoticesIssued',
    components: {
        PreTrialDatePicker,
        LabeledCard
    },
    data: () => ({
        period: null,
        isLoading: false,
        report_category: false,
        engineer_rid: null,
        action_type_rid: null,
        action_reason_rid: null,
        report_categories: [
            { label: 'Юридические лица', value: false },
            { label: 'Физические лица', value: true }
        ]
    }),
    methods: {
        ...mapActions('users', ['getEngList', 'getUserInfo']),
        ...mapActions('refs', ['getReasons', 'getActions']),
        async generateReport() {
            this.isLoading = true;
            if (!this.period) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Не выбран период',
                    color: 'warning'
                });
                this.isLoading = false;
                return;
            }
            const response = await this.$store.dispatch('reports/getReportCreatedActs', {
                period: this.period,
                report_category: this.report_category,
                engineer_rid: this.engineer_rid,
                action_type_rid: this.action_type_rid,
                action_reason_rid: this.action_reason_rid
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Нет данных',
                    color: 'warning'
                });
            }
            this.isLoading = false;
        }
    },
    computed: {
        ...mapState('users', ['itemsEngineer', 'userInfo']),
        ...mapGetters('refs', ['getReasonsList', 'getActionsList']),
        isRoleManagementReport() {
            return this.userInfo['role_code'] ? this.userInfo['role_code'].includes('management_reports') : false;
        },
        reasons() {
            return translate(this.getReasonsList, 'full', this.$i18n.locale);
        },
        actions() {
            return translate(this.getActionsList, 'full', this.$i18n.locale);
        }
    },
    async created() {
        await this.getUserInfo();
        await this.getEngList();
        await this.getReasons();
        await this.getActions();
        if (this.userInfo['role_code'] && this.userInfo['role_code'].includes('management_reports')) {
            this.engineer_rid = [];
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
            this.engineer_rid = [this.userInfo.user_data.isas_engineer_rid];
        }
    }
};
</script>

<style lang="scss" scoped>
#meters-report {
    height: 100%;
}
.label {
    font-weight: 500;
}
.spacer {
    width: 80%;
}
.picker * {
    margin-bottom: 0;
}

@media screen and (max-width: 1440px) {
    .spacer {
        width: 100%;
    }
}
</style>
